/**
 * The Stal-app's client-safe vocabulary (the roster-fields.ts idiom): the
 * chapter labels and icons of the stalafspraken, the photo "hoort bij"
 * labels, the two author sentinels and the hours label. Route components
 * and trays import from here; the *.server.ts modules re-use it.
 */
export const RULE_CHAPTER_NL = {
	algemeen: { label: 'Algemeen', icon: '🏡' },
	staldienst: { label: 'Staldienst', icon: '🧹' },
	paddock: { label: 'Paddock', icon: '🕳' },
	rijbaan: { label: 'Rijbaan', icon: '🏇' },
	ruimte: { label: 'Ruimte', icon: '🔑' },
	voer: { label: 'Voer', icon: '🥕' },
	sleutels: { label: 'Sleutels en codes', icon: '🔑' },
} as const
export type StalRuleChapter = keyof typeof RULE_CHAPTER_NL

/** ChatMessage.authorId of Oyka's own lines (chat.server.ts OYKA_AUTHOR). */
export const OYKA_AUTHOR_ID = 'oyka'
/** The person-id sentinel for E. (brain E_SENTINEL) — she has no CircleRole row. */
export const E_ID = 'E'

export function belongsLabel(kind: string | null, id: string | null): string {
	switch (kind) {
		case 'les':
			return 'les'
		case 'mestdienst':
			return 'mestdienst'
		case 'klus':
			return 'klus'
		case 'paard':
			return id ?? 'paard'
		case 'else':
			return 'Else'
		default:
			return 'los'
	}
}

export function hoursNl(h: number): string {
	if (h === 0.5) return '½ u'
	return `${String(h).replace('.', ',')} u`
}
